import { BaseMethod } from "./_Base";
import { Vector2 } from "three";
export class WindowSizeExpression extends BaseMethod {
  constructor() {
    super(...arguments);
    this._requireDependency = true;
    this._windowSize = new Vector2();
  }
  static requiredArguments() {
    return [[]];
  }
  findDependency(index_or_path) {
    this.param.addGraphInput(this.param.scene().windowController.graphNode());
    return null;
  }
  processArguments(args) {
    return new Promise((resolve) => {
      this._windowSize.set(window.innerWidth, window.innerHeight);
      resolve(this._windowSize);
    });
  }
}
